export const PERMUTAS_LIST = 'PERMUTAS_LIST';
export const PERMUTAS_LIST_START = 'PERMUTAS_LIST_START';
export const PERMUTAS_LIST_SUCCESS = 'PERMUTAS_LIST_SUCCESS';
export const PERMUTAS_LIST_ERROR = 'PERMUTAS_LIST_ERROR';
